export const ACCESS_TOKEN_KEY = 'micast-access-token';
export const REFRESH_TOKEN_KEY = 'micast-rfr';
